// extracted by mini-css-extract-plugin
export default {"btn":"iUMqdWVrBWXb57JlEI3f","downloader":"sAMicFr8P8AwWmSGLuJC","spinner":"z0qVtSzv94yGAmo0s2Yj","export":"jXAOzM4oKP5yFw5cG5wM"};